import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import MultiStepActivationContainer from './Components/MultiStepActivationContainer';
import { useTranslation, Trans } from 'react-i18next';
import i18n from 'i18next';
import images from '../Theming/images';
import { Path } from '../Routing';
import { isIOS, osVersion } from 'react-device-detect';
import {
  ANALYTICS_ACTION_LABELS,
  ANALYTICS_PAGE_NAMES,
  trackActivationActionEvent,
} from '../Common/Analytics/utils';
import { usePageViewTracking, useQuery } from '../Common/Hooks';
import { getAnalytics, logEvent } from 'firebase/analytics';
import app from '../Firebase';

export const MultiStepHeaderText = styled.h3`
  color: smokeBlack;
  text-align: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const BodyContentContainer = styled.div`
  width: 100%;
  min-height: 106px;
  margin-top: 33px;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  justify-content: center;
`;

const IconContentDescription = styled.div`
  color: white;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  padding-top: 10px;
`;

export const FirstA = styled.span`
  font-size: 14px;
`;

export const SecondA = styled.span`
  font-size: 18px;
`;

const TapAATextContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
`;
const TextTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  line-height: 15px;
  margin-bottom: 20px;
  width: 100%;
`;

const StrongText = styled.strong`
  padding-left: 2px;
  padding-right: 2px;
`;

const StyledImage = styled.img`
  margin-top: 5px;
  margin-left: 4px;
  margin-right: 4px;
`;

const FloatingUnionImage = styled.img`
  position: absolute;
  top: 325px;
  left: 50%;
  transform: translateX(-50%);
  width: 33.47px;
  height: 30.5px;
  z-index: 2;
`;

const PartnerPluginActivateMultiStep: React.FC = () => {
  if (i18n.language != 'it') {
    i18n.changeLanguage('it');
  }
  const { activation_permissions } = ANALYTICS_ACTION_LABELS;
  const { activation_instructions_page } = ANALYTICS_PAGE_NAMES;
  const { t } = useTranslation();
  usePageViewTracking(activation_instructions_page, 'TIM');
  const history = useHistory();
  const supportsiOS18 = isIOS && parseInt(osVersion) >= 18;
  const query = useQuery();

  useEffect(() => {
    const initialHeight = window.innerHeight;
    const analytics = getAnalytics(app);

    const interval = setInterval(() => {
      const currentHeight = window.innerHeight;
      const difference = initialHeight - currentHeight;

      if (difference > 44 && difference < 61) {
        history.push({
          pathname: Path.TimPluginActivationAlwaysAllow,
          search: location.search,
        });
      }
    }, 1500);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const messageHandler = (message: any) => {
      if (message && message.data === '') {
        window.location.reload();
      } else if (message) {
        switch (message.data?.type) {
          case 'PluginEnabled': {
            trackActivationActionEvent(
              query,
              'TIM',
              activation_permissions,
              activation_instructions_page,
              {
                permissions: message.data?.givenPermission ? 'Full' : 'Partial',
              }
            );
            logEvent(analytics, 'activation_permissions', {
              permissions: message.data?.givenPermission ? 'Full' : 'Partial',
              partner: 'TIM',
            });
            if (message.data?.givenPermission) {
              history.push({
                pathname: Path.TimPluginActivationStartShopping,
                search: location.search,
              });
            } else {
              history.push({
                pathname: Path.TimPluginActivationPartialPermissions,
                search: location.search,
              });
            }
            break;
          }
        }
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      clearInterval(interval);
      window.removeEventListener('message', messageHandler);
    };
  }, [history]);

  return (
    <MultiStepActivationContainer
      headerShadow
      headerText={'PartnerNewpluginsdkActivate.timLetsActivateHeaderText'}
      image={
        (supportsiOS18
          ? images.partnerpluginsdk_activation_tim_18
          : images.partnerpluginsdk_activation_tim_aa
        )?.default
      }
    >
      <BodyContentContainer>
        <FloatingUnionImage src={images.tim_ios_union_icon?.default} />
        <IconContentDescription>
          {!supportsiOS18 ? (
            <TapAATextContainer>
              <div>
                <Trans
                  i18nKey="PartnerNewpluginsdkActivate.timLetsActivateTapTitleAa"
                  t={t}
                >
                  <FirstA>A</FirstA>
                  <SecondA>A</SecondA>
                </Trans>
              </div>
            </TapAATextContainer>
          ) : (
            <TextTitleContainer>
              <span>
                {t(
                  'PartnerNewpluginsdkActivate.timLetsActivateTapTitle18Part1'
                )}
              </span>
              <StyledImage
                src={images.tim_ios_18_icon?.default}
                width={21}
                height={25}
                alt="ios_18_plugin"
              />
              <Trans
                i18nKey="PartnerNewpluginsdkActivate.timLetsActivateTapTitle18Part2"
                t={t}
              >
                <StrongText>BoldText</StrongText>
              </Trans>
            </TextTitleContainer>
          )}

          <TextTitleContainer>
            <span>
              {t(
                'PartnerNewpluginsdkActivate.timLetsActivateSelectPluginPart1'
              )}
            </span>
            <StyledImage
              src={images.tim_ios_plugin_icon?.default}
              width={26}
              height={25}
              alt="ios_18_plugin"
            />
            <Trans
              i18nKey="PartnerNewpluginsdkActivate.timLetsActivateSelectPluginPart2"
              t={t}
            >
              <StrongText>BoldText</StrongText>
            </Trans>
          </TextTitleContainer>
          <TextTitleContainer>
            <span>
              {t(
                'PartnerNewpluginsdkActivate.timLetsActivateTogglePluginPart1'
              )}
            </span>
            <StyledImage
              src={images.tim_ios_switch_icon?.default}
              width={36}
              height={24}
              alt="ios_18_plugin"
            />
            <Trans
              i18nKey="PartnerNewpluginsdkActivate.timLetsActivateTogglePluginPart2"
              t={t}
            >
              <StrongText>BoldText</StrongText>
            </Trans>
          </TextTitleContainer>
        </IconContentDescription>
      </BodyContentContainer>
    </MultiStepActivationContainer>
  );
};

export default PartnerPluginActivateMultiStep;
